import React, { Fragment } from 'react';
import { Box, FormLabel, Stack, RadioGroup, Radio, Grid, Tooltip, IconButton, InputAdornment, Divider } from '@mui/material';
import { StyledCard, StyledCardTitle, TableBadge, CustomRadio, FlexDiv, CustomSearch } from '../../../../../custom/components';
import AddUserModal from './AddUserModal';
import { EditIcon, KeyIcon, LocationIcon, AddIcon, ExcelIcon } from '../../../../../custom/constants';
import userStyles from './users.module.css';
import styles from '../../../../../custom/style.module.css';
import LocationModal from '../../../common/location/LocationContainer';
import ChangePassword from './ChangePassword';
import DocModalContainer from 'components/pages/common/docModal/DocModalContainer';
import DeactiveModal from './DeactiveUserModal';
import RemoveExpiryModal from './RemoveExpiryModal';
import cookies from 'utils/cookies';
import UserModal from './UserModal';
import { Person, PersonOff, Search } from '@mui/icons-material';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';


const checkperms = (row) => {
  let usecookie = cookies.get('role');
  let flag = false;
  if (row.role === 'System Admin' && (usecookie === 'Supervisor' || usecookie === 'Manager')) {
    flag = true;
  } else if (row.role === 'Manager' && usecookie === 'Supervisor') {
    flag = true;
  }
  return flag;
};
const ManageUser = (props) => {

  const { anchorEl, /*handleDoc,*/ handleTraining, training, doc, filter, onChangeFilter, generatePassword, action, modal, airlineList, userFields, userErrors, handleOpen, onClose, addUser, editUser, stations, onChange, handleChangePassword } = props;

  // Popover action cell as a separate component
  function PopoverActionCell({ row }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setSelectedRow(row);
    };
    const handleClose = () => {
      setAnchorEl(null);
      setSelectedRow(null);
    };
    const open = Boolean(anchorEl);
    return (
      <>
        <LocationIcon
          onClick={handleClick}
          disabled={checkperms(row)}
        />
        <LocationModal
          anchorEl={anchorEl}
          open={open}
          type={'user'}
          handleClose={handleClose}
          name={selectedRow?.first_name + ' ' + selectedRow?.last_name}
          stations={props.stations}
          data={selectedRow}
        />
      </>
    );
  }

  const columns = [
    {
      accessorKey: 'first_name',
      header: 'First Name',
      cell: (info) => {
        const row = info.row.original;
        return (
          <Stack direction='row' spacing={1} alignItems='center'>
            <div>{row.first_name}</div>
            {(!row?.master && row.app === 'TRYPOD') && <div className={userStyles.tryfd}>trypod</div>}
          </Stack>
        );
      },
    },
    {
      accessorKey: 'last_name',
      header: 'Last Name',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'username',
      header: 'User Name',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'email',
      header: 'Email',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'role',
      header: 'Role',
      cell: (info) => {
        const row = info.row.original;
        return (
          <Stack direction='row' spacing={1} alignItems='center'>
            {row.role + ' '}
            <div>&nbsp; &nbsp;</div>
            <Tooltip title={row.airlines && row.airlines[cookies.get('station_code')]?.join(', ')}>
              <div className={userStyles.roles}>
                {row.airlines &&
                  row.airlines[cookies.get('station_code')]?.map((airlines, index) => (
                    <Fragment key={index}>
                      <span className={userStyles.airlines}>{airlines}</span>
                    </Fragment>
                  ))}
              </div>
            </Tooltip>
          </Stack>
        );
      },
    },
    {
      accessorKey: 'contract_types',
      header: 'Department',
      cell: (info) => {
        const row = info.row.original;
        return (
          <Fragment>
            <Tooltip title={row.contract_types?.join(', ')}>
              <div className={userStyles.roles}>
                {row.contract_types?.map((contract_type, index) => (
                  <Fragment key={index}>
                    <span className={userStyles.airlines}>{contract_type}</span>
                  </Fragment>
                ))}
              </div>
            </Tooltip>
          </Fragment>
        );
      },
    },
    {
      accessorKey: 'shoptalk_access',
      header: 'ShopTalk User',
      minWidth: 200,
      flex: 1,
      cell: (info) => {
        const row = info.row.original;
        return (
          <Fragment>
            <div className={userStyles.roles}>
              <span className={userStyles.airlines}>{row?.shoptalk_access ? 'Yes' : 'No'}</span>
            </div>
          </Fragment>
        );
      }
    },
    {
      accessorKey: 'action',
      header: 'Action',
      cell: (info) => {
        const row = info.row.original;
        return (
          <Stack
            direction='row'
            spacing={2}
            justifyContent='center'
            className={userStyles.actionIcons}
          >
            {row.active ? (
              <IconButton
                size='medium'
                title='Deactivate User'
                aria-label='Deactivate User'
                onClick={() => props.handleOpen('deactive_user', 'deactive', row)}
                disabled={checkperms(row)}
                color='primary'
                disableRipple
                disableFocusRipple
                disableTouchRipple
                className={styles.p0}
              >
                <Person sx={{ fontSize: 18 }} />
              </IconButton>
            ) : (
              <IconButton
                size='small'
                title='Reactivate User'
                aria-label='document'
                onClick={() => props.handleOpen('deactive_user', 'active', row)}
                disabled={checkperms(row)}
                color='primary'
                disableRipple
                disableFocusRipple
                disableTouchRipple
                className={styles.p0}
              >
                <PersonOff sx={{ fontSize: 18 }} />
              </IconButton>
            )}
            <KeyIcon
              title='Manage Password'
              onClick={() => props.handleOpen('user_pass', 'edit', row)}
              disabled={checkperms(row) || !row?.master}
            />
            <TableBadge
              color='error'
              badgeContent={row.stations && row.stations.length}
              className={checkperms(row) ? styles.disabledImg : ''}
            >
              <PopoverActionCell row={row} />
            </TableBadge>
            <EditIcon
              onClick={() => props.handleOpen('user', 'edit', row)}
              disabled={checkperms(row)}
            />
          </Stack>
        );
      },
    },
  ];

  return (
    <div>
      <StyledCard>
        <Box className={`${styles.mb3} ${styles.fSpaceBtw}`} >
          <Grid container columnSpacing={1} rowSpacing={1}>
            <Grid item xs={6} sm={6} md={6} lg={1} order={{
              xs: 1,
              sm: 1,
              md: 1,
              lg: 1,
            }}>
              <FlexDiv><StyledCardTitle>User List</StyledCardTitle></FlexDiv>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg order={{
              xs: 3,
              sm: 3,
              md: 3,
              lg: 2,
            }}>
              <Stack direction='row' spacing={2} justifyContent={{
                lg: 'flex-end',
                md: 'right',
                sm: 'left',
              }}
              alignItems={'center'} flexWrap='wrap' mr={2}>
                <FormLabel component='small' className={`${styles.xsW100} ${styles.pr2}`}><small>Filter:</small> </FormLabel>
                <RadioGroup aria-labelledby='user-status' name='type' value={filter.type} defaultValue='ALL' onChange={onChangeFilter} row className={styles.ml0}>
                  <Stack direction='row' spacing={{
                    xs: 1,
                    sm: 2,
                  }} flexWrap='wrap'>
                    <CustomRadio control={<Radio size='small' />} value='ALL' label='All Users' />
                    <CustomRadio control={<Radio size='small' />} value='ACTIVE' label='Active Users' />
                    <CustomRadio control={<Radio size='small' />} value='INACTIVE' label='Inactive Users' />
                    <CustomRadio control={<Radio size='small' />} value='DEACTIVATED' label='Deactivated Users' />
                  </Stack>
                </RadioGroup>

                <Divider orientation='vertical' variant='middle' flexItem sx={{
                  backgroundColor: '#ffffff8f',
                  height: '30px',
                  '@media (max-width: 900px)': { display: 'none', }
                }} />

                <CustomSearch
                  id='search'
                  variant='outlined'
                  size='small'
                  type='search'
                  placeholder='Search'
                  name='search'
                  className={`${styles.brInput} ${userStyles.searchInput}`}
                  value={props?.filterValue?.search || ''}
                  onChange={props.handleFilterChange}
                  InputProps={{
                    endAdornment: <InputAdornment position='end'>
                      <IconButton
                        size='small'
                        aria-label='search'
                        edge='end'
                        onClick={props.filterData}
                      >
                        <Search fontSize='inherit' />
                      </IconButton>
                    </InputAdornment>,
                  }}
                  onKeyDown={
                    (e) => {
                      if (e.key === 'Enter') {
                        props.filterData(true);
                      }
                    }
                  }
                />
              </Stack>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={6} lg={5} order={{
              xs: 3,
              sm: 4,
              md: 4,
              lg: 3,
            }} className={styles.textCenter} >
              <CustomCheckbox name='expiry' checked={filter.expiry} control={<Checkbox inputProps={{ 'aria-label': '', }} size='small' onChange={onChangeFilter} />}
                label={<div style={{ marginTop: '4px' }}>Show users with training expiring in &nbsp;
                  <TextField
                    className={userStyles.tableTextField}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*'
                    }}
                    onChange={onChangeFilter}
                    name='day'
                    value={filter.day}
                  /> days</div>} 
              />
            </Grid> */}
            <Grid item xs={6} sm={6} md={6} lg={'auto'} order={{
              xs: 2,
              sm: 2,
              md: 2,
              lg: 4,
            }}>
              <Stack direction='row' justifyContent='flex-end' alignItems='center' height='100%' spacing={2}>
                <AddIcon onClick={() => props.handleOpen('user', 'add', {})} title='Add User' />
                <ExcelIcon onClick={props.handleExport} title='Export to Excel' />
              </Stack>
            </Grid>
          </Grid>

        </Box>
        <div className={styles.tableWrapper}>
          <Box className={`${styles.tableOuter} ${userStyles.userTableOuter}`}>
            {/* <StyledDataGrid
              {...DataGridProps}
              rows={props.filteredData}
              columns={columns}
              param={props.filteredData?.length}
            /> */}
            <TableWrapper columns={columns} data={props.filteredData} />
          </Box>
        </div>
      </StyledCard>
      <UserModal modal={modal} onClose={onClose} otherUserList={props.otherUserList} tryUserFields={props.tryUserFields} onChangeTry={props.onChangeTry} onSearchTry={props.onSearchTry} handleOpen={props.handleOpen} />
      <AddUserModal
        modal={modal}
        action={action}
        handleOpen={handleOpen}
        onClose={onClose}
        airlineList={airlineList}
        userFields={userFields}
        userErrors={userErrors}
        addUser={addUser}
        editUser={editUser}
        onChange={onChange}
        stations={stations}
      />

      <ChangePassword
        modal={modal}
        handleOpen={handleOpen}
        onClose={onClose}
        userFields={userFields}
        userErrors={userErrors}
        handleChangePassword={handleChangePassword}
        onChange={onChange}
        generatePassword={generatePassword}
        passwordVal={props.passwordVal}
        successModal={props.successModal}
      />

      <DeactiveModal
        modal={modal}
        action={action}
        userFields={userFields}
        userErrors={userErrors}
        active={props.active}
        deactive={props.deactive}
        onChange={onChange}
        onClose={onClose}
      />

      <RemoveExpiryModal
        anchorEl={anchorEl}
        handleTraining={handleTraining}
        training={training}
        doc={doc}
        handleRetraining={props.handleRetraining}
        onChangeUser={props.onChangeUser}
      />

      <DocModalContainer />

    </div>
  );
};

export default ManageUser;
